import { render, staticRenderFns } from "./rebate.vue?vue&type=template&id=52afad39&scoped=true&"
import script from "./rebate.vue?vue&type=script&lang=js&"
export * from "./rebate.vue?vue&type=script&lang=js&"
import style0 from "./rebate.vue?vue&type=style&index=0&id=52afad39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afad39",
  null
  
)

export default component.exports